const CACHE_KEY = 'customerCategoryContext'

const DEFAULT_CONTEXT = {
  brandId: 1,
  channelId: 1,
  siteId: 1,
  terminalId: 1
}

const normalizeId = value => {
  const numberValue = Number(value)
  return Number.isNaN(numberValue) ? value : numberValue
}

export const getCustomerCategoryContext = () => {
  try {
    const cachedContext = JSON.parse(localStorage.getItem(CACHE_KEY))
    if (!cachedContext || typeof cachedContext !== 'object') {
      return { ...DEFAULT_CONTEXT }
    }

    return Object.keys(DEFAULT_CONTEXT).reduce(
      (context, key) => ({
        ...context,
        [key]:
          cachedContext[key] === undefined || cachedContext[key] === null
            ? DEFAULT_CONTEXT[key]
            : normalizeId(cachedContext[key])
      }),
      {}
    )
  } catch (error) {
    return { ...DEFAULT_CONTEXT }
  }
}

export const setCustomerCategoryContext = context => {
  try {
    const cachedContext = Object.keys(DEFAULT_CONTEXT).reduce(
      (result, key) => ({ ...result, [key]: context[key] }),
      {}
    )
    localStorage.setItem(CACHE_KEY, JSON.stringify(cachedContext))
  } catch (error) {
    // localStorage 不可用时沿用当前页面状态，不影响原有查询逻辑。
  }
}
